import { createContext, useContext, useEffect, useState } from "react";
import { authService } from "../services/authService";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = authService.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);

      // Sync with localStorage for legacy support if needed, or remove entirely
      try {
        if (user) {
          localStorage.setItem("userID", JSON.stringify(user.uid));
        } else {
          localStorage.removeItem("userID");
        }
      } catch (error) {
        console.warn("LocalStorage access denied or failed:", error);
      }
    });

    return unsubscribe;
  }, []);

  const signup = (email, password) => {
    return authService.signUp(email, password);
  };

  const login = (email, password) => {
    return authService.signIn(email, password);
  };

  const logout = () => {
    return authService.logout();
  };

  const resetPassword = (email) => {
    return authService.resetPassword(email);
  };

  const verifyEmail = (user) => {
    return authService.verifyEmail(user);
  };

  const value = {
    currentUser,
    signup,
    login,
    logout,
    resetPassword,
    verifyEmail,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
